import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivityDistanceNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M16 14.825a4.825 4.825 0 110-9.65 4.825 4.825 0 010 9.65zm0-8a3.175 3.175 0 100 6.35 3.175 3.175 0 000-6.35z" />
        <path d="M16 31.759L7.048 14.9A9.88 9.88 0 018.835 3.106a10.236 10.236 0 0114.33 0 9.88 9.88 0 011.786 11.8zm0-29.931A8.527 8.527 0 009.994 4.28 8.246 8.246 0 008.5 14.122L16 28.241l7.5-14.119a8.246 8.246 0 00-1.494-9.842A8.527 8.527 0 0016 1.828z" />
      </g>
    </svg>
  )
);
SvgActivityDistanceNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgActivityDistanceNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivityDistanceNormalMedium;
